import React, { useState } from 'react';
import { fileRequester } from 'App';

const ContractTemplateUpload = () => {
    const [file, setFile] = useState(null);
    const [templateName, setTemplateName] = useState('');
    const [description, setDescription] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile && selectedFile.type === 'application/pdf') {
            setFile(selectedFile);
            
            // PDF 미리보기 생성
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreviewUrl(e.target.result);
            };
            reader.readAsDataURL(selectedFile);
        } else {
            alert('PDF 파일만 업로드 가능합니다.');
            event.target.value = null;
        }
    };

    const handleUpload = async () => {
        if (!file || !templateName) {
            alert('파일과 템플릿 이름을 입력해주세요.');
            return;
        }

        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('name', templateName);
            
            if (description) {
                formData.append('description', description);
            }

            fileRequester.uploadContractTemplate(formData, (response, error) => {
                if (error) {
                    console.error('템플릿 업로드 오류:', error);
                    alert('템플릿 업로드 중 오류가 발생했습니다.');
                    return;
                }

                if (response) {
                    alert('템플릿 PDF가 성공적으로 업로드되었습니다.');
                    // 필드 초기화
                    setFile(null);
                    setTemplateName('');
                    setDescription('');
                    setPreviewUrl(null);
                }
            });
        } catch (error) {
            console.error('템플릿 업로드 중 오류:', error);
            alert('템플릿 업로드 중 오류가 발생했습니다.');
        }
    };

    return (
        <div style={{ 
            maxWidth: '600px', 
            margin: '0 auto', 
            padding: '20px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        }}>
            <h2 style={{ 
                textAlign: 'center', 
                marginBottom: '20px', 
                color: '#333' 
            }}>
                계약서 템플릿 PDF 업로드
            </h2>

            {/* 템플릿 이름 입력 */}
            <div style={{ marginBottom: '15px' }}>
                <label style={{ 
                    display: 'block', 
                    marginBottom: '8px', 
                    fontWeight: 'bold' 
                }}>
                    템플릿 이름
                </label>
                <input 
                    type="text"
                    value={templateName}
                    onChange={(e) => setTemplateName(e.target.value)}
                    placeholder="템플릿 이름을 입력해주세요"
                    style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '4px'
                    }}
                />
            </div>

            {/* 템플릿 설명 입력 (선택) */}
            <div style={{ marginBottom: '15px' }}>
                <label style={{ 
                    display: 'block', 
                    marginBottom: '8px', 
                    fontWeight: 'bold' 
                }}>
                    템플릿 설명 (선택)
                </label>
                <textarea 
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="템플릿에 대한 설명을 입력해주세요 (선택)"
                    style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        minHeight: '100px'
                    }}
                />
            </div>

            {/* PDF 파일 업로드 */}
            <div style={{ marginBottom: '15px' }}>
                <label style={{ 
                    display: 'block', 
                    marginBottom: '8px', 
                    fontWeight: 'bold' 
                }}>
                    PDF 파일 선택
                </label>
                <input 
                    type="file" 
                    accept=".pdf"
                    onChange={handleFileChange}
                    style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '4px'
                    }}
                />
            </div>

            {/* PDF 미리보기 */}
            {previewUrl && (
                <div style={{ 
                    marginBottom: '15px', 
                    textAlign: 'center' 
                }}>
                    <h3>PDF 미리보기</h3>
                    <iframe 
                        src={previewUrl} 
                        width="100%" 
                        height="500px"
                        style={{ 
                            border: '1px solid #ddd',
                            borderRadius: '4px'
                        }}
                    />
                </div>
            )}

            {/* 업로드 버튼 */}
            <button 
                onClick={handleUpload}
                disabled={!file || !templateName}
                style={{
                    width: '100%',
                    padding: '12px',
                    backgroundColor: file && templateName ? '#007bff' : '#cccccc',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: file && templateName ? 'pointer' : 'not-allowed'
                }}
            >
                템플릿 PDF 업로드
            </button>
        </div>
    );
};

export default ContractTemplateUpload;